import type { SupportedActionReward } from 'loyalty/constants/loyaltyActionRewards'
// import { getBaseTierOfferWithNoJoiningFee } from 'selectors/luxPlusSelectors'

/** Per-action fields for the action-reward earn request. */
interface LoyaltyActionRewardEarnRequest {
  productType?: App.LoyaltyProductType
  pointKey?: string
  packageId?: string
  offerId?: string
  region?: string
  orderId?: string
  itemId?: string
  earnKey?: string
  promoId?: string
}

type LoyaltyActionRewardEarnRequestResolver = (
  state: App.State,
) => LoyaltyActionRewardEarnRequest | undefined

/** Per-action resolvers for earn request metadata */
const ACTION_REWARD_EARN_REQUEST_RESOLVERS: Partial<
  Record<SupportedActionReward, LoyaltyActionRewardEarnRequestResolver>
> = {
  // [SupportedActionReward.LUX_PLUS_RENEWAL]: (state) => {
  //   // Hidden dependency: earn amount needs the catalog no-joining-fee offer UUID,
  //   // not currentSubscriptionOfferId (that may be the joining-fee SKU). This
  //   // resolver only reads Redux — callers must load
  //   // state.luxPlus.products.subscription first or batch calculate omits offerId.
  //   const offerId = getBaseTierOfferWithNoJoiningFee(state)?.id
  //   if (!offerId) return undefined
  //
  //   return {
  //     offerId,
  //   }
  // },
}

function getLoyaltyActionRewardEarnRequest(
  actionName: SupportedActionReward,
  state: App.State,
): LoyaltyActionRewardEarnRequest | undefined {
  return ACTION_REWARD_EARN_REQUEST_RESOLVERS[actionName]?.(state)
}

export default getLoyaltyActionRewardEarnRequest
